/**
* @name: el-remark
* @author: weiyong
* @date: 2024-09-26 10:10
* @description：el-remark
* @update: 2024-09-26 10:10
*/
<template>
  <div v-if="showRemarkText || showInputTooltip" class="input-remark">
    <a-tooltip v-if="showInputTooltip" >
      <template #title>{{ props.remark }}</template>
      <span style="color:#666;" :style="remarkSty" class="remix-icon ri-question-line1"></span>
    </a-tooltip>
    <span :style="remarkSty" v-else-if="showRemarkText">{{ props.remark }}</span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "el-remark",
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip} from 'ant-design-vue';
import {REMARK_TOOLTIP_ON_LABEL_KEY} from "@/main-page-form/common/remarkTooltip";

interface propTypes {
  props: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  props: {},
});
const {props} = toRefs(propsPage);
const remarkTooltipOnLabel = inject(REMARK_TOOLTIP_ON_LABEL_KEY, false);

const showRemarkText = computed(() => !!(unref(props).remark && !unref(props).remarkToolTipFlag));
const showInputTooltip = computed(() => {
  const p = unref(props);
  return !!(p.remark && p.remarkToolTipFlag && !unref(remarkTooltipOnLabel));
});

const remarkSty=computed(()=>{
  const sty={};
  if(unref(props).remarkFontSize){
    sty['fontSize']=unref(props).remarkFontSize+'px';
  }
  if(unref(props).remarkFontColor){
    sty['color']=unref(props).remarkFontColor;
  }
  return sty;
})
</script>

<style type="text/css" lang="less">

</style>
